export class QueueModel {
    id: number;
    name: string;
    description: string;
    assignedToRoles: string[];
    priority: number;
    filters: string;
    created: string;
    updated: null | string;
    createdBy: QueueOwner;
    updatedBy: QueueOwner;
}

export class QueueOwner {
    id: string;
    firstName: string;
    lastName: string;
}

export class QueuesColumnModel {
    private _columns: Array<any>;

    constructor() {
        this._columns = [
            {
                headerName: 'Priority',
                field: 'priority',
                width: 120,
            },
            {
                headerName: 'Queue Name',
                field: 'name',
                cellRenderer: 'customNameCellComponent',
                width: 120,
            },
            {
                headerName: 'Description',
                field: 'description',
                width: 120,
            },
            {
                headerName: 'Actions',
                field: 'actions',
                width: 100,
                cellRenderer: 'customActionCellComponent',
            },
        ];
    }

    get columns(): Array<any> {
        return this._columns;
    }
}

export class GetQueuesFilters {
    name: string;
}

export class QueuesResponseModel {
    data: QueueModel[];
    totalCount: number;
    offset: number;
    limit: number;
}

export class QueueOptionSets {
    key: string;
    label: string;
    source?: string;  
    options?: string[];
  }

export class QueueRolesResponseModel {
    data: RolesModel[];
    totalCount: number;
    offset: number;
    limit: number;
}

export class RolesModel {
    id: string;
    name: string;
}

export class SaveQueueEditorPayload {
      name: string;
      description: string;
      assignedToRoles: string[];
      filters: string;
      priority: number;
}

export class ResolveByDateAndLimitPayload {
    startDate: string;
    endDate: string;
    limit: number;
    maxParallelism: 1;
}